import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for invitation hooks
 * Keys match backend controller method names
 */
export const invitationsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["invitations", "findAll", params] as const)
      : (["invitations", "findAll"] as const),
  findOne: (uuid: string) => ["invitations", "findOne", uuid] as const,
} as const
